import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { HostShell, LoadingPage, Protected, Toasts } from './components';
const LandingPage = lazy(() => import('./pages/Landing').then((m) => ({ default: m.LandingPage })));

const AuthPage = lazy(() => import('./pages/Auth').then((m) => ({ default: m.AuthPage })));
const ForgotPassword = lazy(() =>
  import('./pages/Auth').then((m) => ({ default: m.ForgotPassword })),
);
const ResetPassword = lazy(() =>
  import('./pages/Auth').then((m) => ({ default: m.ResetPassword })),
);
const ApprovalPending = lazy(() =>
  import('./pages/Auth').then((m) => ({ default: m.ApprovalPending })),
);
const HostApprovals = lazy(() =>
  import('./pages/Admin').then((m) => ({ default: m.HostApprovals })),
);
const Dashboard = lazy(() => import('./pages/Dashboard').then((m) => ({ default: m.Dashboard })));
const Builder = lazy(() => import('./pages/Builder').then((m) => ({ default: m.Builder })));
const HostSession = lazy(() => import('./pages/Live').then((m) => ({ default: m.HostSession })));
const ProjectorSession = lazy(() =>
  import('./pages/Live').then((m) => ({ default: m.ProjectorSession })),
);
const JoinPage = lazy(() => import('./pages/Live').then((m) => ({ default: m.JoinPage })));
const Reports = lazy(() => import('./pages/Reports').then((m) => ({ default: m.Reports })));
const ReportDetail = lazy(() =>
  import('./pages/Reports').then((m) => ({ default: m.ReportDetail })),
);
const QuestionBank = lazy(() =>
  import('./pages/QuestionBank').then((m) => ({ default: m.QuestionBank })),
);
const MediaLibrary = lazy(() =>
  import('./pages/MediaLibrary').then((m) => ({ default: m.MediaLibrary })),
);
const Classes = lazy(() => import('./pages/Workspace').then((m) => ({ default: m.Classes })));
const ClassDetail = lazy(() =>
  import('./pages/Workspace').then((m) => ({ default: m.ClassDetail })),
);
const Settings = lazy(() => import('./pages/Workspace').then((m) => ({ default: m.Settings })));
const HostAssignment = lazy(() =>
  import('./pages/Assignments').then((m) => ({ default: m.HostAssignment })),
);
const StudentAssignment = lazy(() =>
  import('./pages/Assignments').then((m) => ({ default: m.StudentAssignment })),
);
const AssignmentEntry = lazy(() =>
  import('./pages/Assignments').then((m) => ({ default: m.AssignmentEntry })),
);

export default function App() {
  return (
    <>
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/approval-pending" element={<ApprovalPending />} />
          <Route path="/join" element={<JoinPage />} />
          <Route path="/join/:code" element={<JoinPage />} />
          <Route path="/assign" element={<AssignmentEntry />} />
          <Route path="/assign/:code" element={<StudentAssignment />} />
          <Route element={<Protected />}>
            <Route element={<HostShell />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/quizzes" element={<Dashboard full />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/reports/:id" element={<ReportDetail />} />
              <Route path="/classes" element={<Classes />} />
              <Route path="/classes/:id" element={<ClassDetail />} />
              <Route path="/question-bank" element={<QuestionBank />} />
              <Route path="/media" element={<MediaLibrary />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/admin/hosts" element={<HostApprovals />} />
            </Route>
            <Route path="/quizzes/new" element={<Builder />} />
            <Route path="/quizzes/:id/edit" element={<Builder />} />
            <Route path="/sessions/:id/host" element={<HostSession />} />
            <Route path="/sessions/:id/projector" element={<ProjectorSession />} />
            <Route path="/assignments/:id/host" element={<HostAssignment />} />
          </Route>
          <Route
            path="*"
            element={
              <main className="grid min-h-screen place-items-center p-6 text-center">
                <div>
                  <p className="eyebrow">404</p>
                  <h1 className="mt-2 text-4xl font-extrabold">This room isn’t here.</h1>
                  <a className="btn-primary mt-6" href="/">
                    Back to QuizRoom
                  </a>
                </div>
              </main>
            }
          />
        </Routes>
      </Suspense>
      <Toasts />
    </>
  );
}
